var angular=window.angular,ngModule;
try {ngModule=angular.module(["ng"])}
catch(e){ngModule=angular.module("ng",[])}
var v1=" <div class=\"modal-header\"> <h3 class=\"modal-title\" id=\"modal-title\"> {{ $ctrl.Title | i18next }} </h3> </div> <div class=\"modal-body\" id=\"modal-body\"> {{ $ctrl.Message | i18next }} </div> <div class=\"modal-footer\"> <button ng-repeat=\"button in $ctrl.Buttons\" class=\"btn\" ng-class=\"[ button.Class ]\" type=\"button\" ng-click=\"$ctrl.Click(button)\">{{ button.Text | i18next }} </button> </div>";
var id1="modalServiceModal.html";
ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);
module.exports=v1;


//////////////////
// WEBPACK FOOTER
// ./src/core/modalService/modalServiceModal.html
// module id = 72
// module chunks = 0 2